import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Chip from '../Chip'
import { applyTextStyle } from '../../styles/typography'

export interface FilterChipDescriptor {
  key: string
  label: string
  onRemove?: () => void
}

interface IProps {
  chips: FilterChipDescriptor[]
  countLabel?: string
  onClearAll?: () => void
  clearAllLabel?: string
  className?: string
}

const FilterChips: React.FC<IProps> = ({
  chips,
  countLabel,
  onClearAll,
  clearAllLabel,
  className,
}) => {
  const { t } = useTranslation()
  if (chips.length === 0 && !countLabel) return null

  const resolvedClearAllLabel = clearAllLabel ?? t('general.forms.clearFilter')

  return (
    <Wrapper className={className}>
      <Inner>
        {countLabel && <CountLabel>{countLabel}</CountLabel>}
        {chips.map((chip) => (
          <Chip key={chip.key} label={chip.label} onRemove={chip.onRemove} />
        ))}
      </Inner>
      {onClearAll && chips.length > 0 && (
        <ClearAllLink type="button" onClick={onClearAll}>
          {resolvedClearAllLabel}
        </ClearAllLink>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

const CountLabel = styled.span`
  ${applyTextStyle('caption')}
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;
`

const ClearAllLink = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  ${applyTextStyle('labelHeavy')}
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

export default FilterChips
